<template lang="pug">
  div#member-list
    template(v-if="!initialLoadComplete")
      VclTable(:rows="7" :columns="3")
    WtEntityTable(
      v-else
      title="Member List"
      :data="_.get(memberResponseObject, 'data', [])"
      :pagination-object="memberResponseObject.pagination"
      :fetch-action="fetchAction"
      default-sort-field="username"
      :empty-message="emptyMessageText"
      enable-search
      @search="onSearch"
      searchPlaceholder="Search by username, name, or email address..."
    )
      BTableColumn(
        :cell-class="'has-text-hover'"
        field="username"
        label="Username"
        sortable
        width=""
        v-slot="column"
      )
        WtRouterLink(
          to="ProfilePage"
          :params="{ username: column.row.username }"
          type="table"
        )
          WtTableCellLongText(:text="column.row.username")
      BTableColumn(field="email" label="Email" sortable v-slot="column")
        WtTableCellLongText(:text="column.row.email")
      BTableColumn(field="walk_organizations_admins.admin_id" label="Admin" sortable width="1rem" v-slot="column")
        span(:class="isAdminClass(column.row)") {{ isAdminText(column.row) }}
      BTableColumn(width="1rem" v-slot="column")
        WtButton(isText bold @click.native="navigateToEditMember(column.row.id)") EDIT
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import VclTable from "@@/VclTable/VclTable";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtTableCellLongText from "@@/WtTableCellLongText/WtTableCellLongText";

export default {
  name: "MemberList",

  components: {
    WtEntityTable,
    WtButton,
    VclTable,
    WtRouterLink,
    WtTableCellLongText
  },

  mixins: [tablePropsMixin],

  props: {
    memberResponseObject: {
      type: Object,
      required: true
    },

    initialLoadComplete: {
      type: Boolean,
      default: false
    },

    fetchAction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      searching: false
    };
  },

  computed: {
    emptyMessageText() {
      return this.searching
        ? "No members found with that name."
        : "No members found.";
    }
  },

  methods: {
    onSearch($event) {
      this.$emit("search", $event);
      $event === "" ? (this.searching = false) : (this.searching = true);
    },

    navigateToEditMember(memberId) {
      this.$router.push({
        name: "MemberCenterSettingsIndividual",
        params: {
          id: memberId
        }
      });
    },

    isAdminText(member) {
      return this._.has(member, "programAdmin.id") ? "Yes" : "No";
    },

    isAdminClass(member) {
      return this._.has(member, "programAdmin.id")
        ? "has-text-success has-text-weight-semibold"
        : "";
    }
  }
};
</script>

<style lang="sass"></style>
